"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastBaseWidget = exports.ToastSpacing = exports.ToastHeight = exports.ToastMessageTestIdSuffix = exports.ToastContentTestIdSuffix = exports.ToastDivTestIdSuffix = exports.ToastType = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Localize_1 = require("../../../gen-src/Localize");
var StatusIcons_1 = require("../../icons/StatusIcons");
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var AlertStyles_1 = require("../AlertStyles");
Object.defineProperty(exports, "ToastType", { enumerable: true, get: function () { return AlertStyles_1.AlertType; } });
var CloseButtonWidget_1 = require("../Button/CloseButtonWidget");
var TextLinkWidget_1 = require("../TextLinkWidget");
var DefaultActionHref = 'javascript:void(0)';
exports.ToastDivTestIdSuffix = 'toast-widget';
exports.ToastContentTestIdSuffix = 'toast-content';
exports.ToastMessageTestIdSuffix = 'toast-message';
exports.ToastHeight = 40;
exports.ToastSpacing = 8;
var FontSize = TabStyles_1.TabStyles.Typography.Sizing.Default;
var CloseButtonSize = 18;
var ToastRootStyleName = TypeStyle.style({
    alignItems: 'flex-start',
    border: '1px solid transparent',
    borderLeftWidth: 8,
    borderRadius: 4,
    boxShadow: TabStyles_1.TabStyles.Shadow.Standard,
    boxSizing: 'border-box',
    color: '#333',
    display: 'inline-flex',
    flexDirection: 'row',
    fontSize: FontSize,
    justifyContent: 'flex-start',
    marginBottom: 3,
    minHeight: exports.ToastHeight,
    padding: "10px " + exports.ToastSpacing * 2 + "px 10px " + exports.ToastSpacing + "px",
    position: 'relative',
    visibility: 'visible',
});
var StatusIconStyleName = TypeStyle.style({
    marginTop: 2,
});
var ContentDivStyleName = TypeStyle.style({
    display: 'flex',
    lineHeight: 1.5,
});
var MessageContainerBaseStyleName = TypeStyle.style({
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: -exports.ToastSpacing,
    position: 'relative',
    $nest: {
        '&::after': {
            bottom: exports.ToastSpacing,
            content: "\"\"",
            position: 'absolute',
            right: 0,
            top: 0,
            width: 1,
        },
        '&.success::after': {
            backgroundColor: AlertStyles_1.ColorMap.success.accentColor,
        },
        '&.info::after': {
            backgroundColor: AlertStyles_1.ColorMap.info.accentColor,
        },
        '&.warning::after': {
            backgroundColor: AlertStyles_1.ColorMap.warning.accentColor,
        },
        '&.error::after': {
            backgroundColor: AlertStyles_1.ColorMap.error.accentColor,
        },
    }
});
var MessageStyleName = TypeStyle.style({
    margin: exports.ToastSpacing,
    marginTop: 0,
});
var ActionContainerStyleName = TypeStyle.style({
    marginBottom: exports.ToastSpacing,
});
var ActionLinkStyleName = TypeStyle.style({
    marginLeft: exports.ToastSpacing - 1,
    marginRight: exports.ToastSpacing * 2,
});
var CloseButtonStyleName = TypeStyle.style({
    cursor: 'pointer',
    flexShrink: 0,
    margin: 0,
    marginLeft: exports.ToastSpacing * 2,
    height: CloseButtonSize,
    width: CloseButtonSize,
});
exports.ToastBaseWidget = function (props) {
    var actionHref = props.actionHref, actionMessage = props.actionMessage, children = props.children, className = props.className, message = props.message, onAction = props.onAction, onCloseRequest = props.onCloseRequest, testId = props.testId, toastType = props.toastType, htmlAttrs = tslib_1.__rest(props, ["actionHref", "actionMessage", "children", "className", "message", "onAction", "onCloseRequest", "testId", "toastType"]);
    // tslint:disable-next-line:no-any
    var prefixText = Localize_1.Messages[toastType + 'ToastPrefix']();
    var handleActionLinkClick = React.useCallback(function (e) {
        if (onAction || actionHref === DefaultActionHref) {
            e.preventDefault();
            onAction === null || onAction === void 0 ? void 0 : onAction();
        }
    }, [onAction]);
    return (React.createElement("div", tslib_1.__assign({ className: TypeStyle.classes(ToastRootStyleName, AlertStyles_1.AlertBaseColorStyleName, className, toastType), "data-tb-test-id": Declarative_1.makeTestId(testId, exports.ToastDivTestIdSuffix) }, htmlAttrs),
        React.createElement("div", { className: ContentDivStyleName, "data-tb-test-id": Declarative_1.makeTestId(testId, exports.ToastContentTestIdSuffix) },
            React.createElement(StatusIcons_1.StatusIcon, { type: toastType, className: StatusIconStyleName }),
            React.createElement("div", { className: TypeStyle.classes(MessageContainerBaseStyleName, toastType) },
                React.createElement("div", { className: MessageStyleName, role: 'alert', "data-tb-test-id": Declarative_1.makeTestId(testId, exports.ToastMessageTestIdSuffix) },
                    React.createElement("span", { style: { position: 'absolute', color: 'transparent', zIndex: -1 } }, prefixText),
                    message,
                    children),
                React.createElement("div", { className: ActionContainerStyleName }, actionMessage &&
                    React.createElement(TextLinkWidget_1.TextLinkWidget, { children: actionMessage, className: ActionLinkStyleName, href: actionHref, kind: TextLinkWidget_1.TextLinkKind.Standalone, onClick: handleActionLinkClick, target: '_blank', testId: testId })))),
        React.createElement(CloseButtonWidget_1.CloseButtonWidget, { className: TypeStyle.classes(CloseButtonStyleName, 'prominent'), "data-tb-test-id": 'toast-close-Button', onClick: onCloseRequest, testId: null })));
};
exports.ToastBaseWidget.displayName = 'ToastBaseWidget';
exports.ToastBaseWidget.defaultProps = { actionHref: DefaultActionHref };
//# sourceMappingURL=ToastBase.js.map